import React, { useState } from 'react';
import { BarList, Btn, DataTable, KPI, KPIRow, Loading, Msg, Section, Select, useAdminGet } from '../kit';

/**
 * Admin → For You & What's New → "What's New · Usage": the page's clicks from
 * site_events (trackClick's first-party mirror; Backend/whatsnew.py `usage`).
 */

const S = 'whatsnew';
const ACTION_LABELS: Record<string, string> = {
  whatsnew_view: 'Page views',
  whatsnew_section_view: 'Section seen',
  whatsnew_university_explore: 'New university → Explore',
  whatsnew_change_open: 'IP added / removed → open',
  whatsnew_tab: 'Category tab',
  whatsnew_industry: 'Industry filter',
  whatsnew_dates: 'Date range',
  whatsnew_item_source: 'News → View source',
  whatsnew_view_all: 'View all <category>',
};

const Top: React.FC<{ title: string; rows: any[]; keyLabel: string }> = ({ title, rows, keyLabel }) => (
  <Section title={title}>
    <DataTable rows={rows} columns={['label', 'clicks', 'people']} labels={{ label: keyLabel }}
      empty="No clicks in this period." maxHeight="16rem" />
  </Section>
);

const Usage: React.FC = () => {
  const [days, setDays] = useState('30');
  const res = useAdminGet<any>(S, 'usage', { days }, [days]);
  const d = res.data;
  const k = d?.kpis || {};
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <Select value={days} onChange={setDays} options={['7', '30', '90', '365']}
          labels={{ '7': 'Last 7 days', '30': 'Last 30 days', '90': 'Last 90 days', '365': 'Last 12 months' }} />
        <Btn small onClick={res.reload}>Refresh</Btn>
      </div>
      {res.error && <Msg kind="error">{res.error}</Msg>}
      {res.loading && !d ? <Loading /> : d && (
        <>
          <KPIRow>
            <KPI label="Page views" value={(k.views || 0).toLocaleString()} />
            <KPI label="Viewers" value={(k.viewers || 0).toLocaleString()} hint={`${k.members || 0} signed-in members`} />
            <KPI label="Engaged" value={(k.engaged || 0).toLocaleString()} hint="clicked anything on the page" />
            <KPI label="Source clicks" value={(k.source_clicks || 0).toLocaleString()} hint="news → View source" />
            <KPI label="Platform clicks" value={(k.platform_clicks || 0).toLocaleString()} hint="Explore / View new techs / profile" />
          </KPIRow>
          <Section title="Clicks by action">
            <BarList items={Object.entries(d.per_action || {}).map(([a, n]) => ({ label: ACTION_LABELS[a] || a, value: Number(n) }))} />
          </Section>
          <Section title="Per day (IST)">
            <DataTable rows={(d.per_day || []).slice().reverse()} columns={['day', 'views', 'clicks']}
              empty="No visits in this period." maxHeight="16rem" csvName="whatsnew_usage_daily" />
          </Section>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <Top title="News items opened" rows={d.top?.items || []} keyLabel="Item" />
            <Top title="New universities explored" rows={d.top?.universities || []} keyLabel="University" />
            <Top title="IP changes opened" rows={d.top?.changes || []} keyLabel="University" />
            <Top title="Category tabs" rows={d.top?.tabs || []} keyLabel="Category" />
            <Top title="Industry filter" rows={d.top?.industries || []} keyLabel="Industry" />
            <Top title="View all" rows={d.top?.view_all || []} keyLabel="Category" />
          </div>
        </>
      )}
    </div>
  );
};

export default Usage;
